import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';

const EmpresasPage = () => {
  const [activeTab, setActiveTab] = useState('servicios');

  const handleWhatsAppContact = () => {
    window.open('https://wa.me/573202047129?text=Hola, me gustaría solicitar información sobre sus servicios empresariales B2B', '_blank');
  };

  const handleScheduleMeeting = () => {
    window.open('https://wa.me/573202047129?text=Hola, me gustaría agendar una reunión para conocer sus soluciones empresariales', '_blank');
  };

  const b2bServices = [
    {
      icon: "ri-building-2-line",
      title: "Soporte Técnico Especializado",
      description: "Asistencia técnica dedicada para talleres automotrices",
      features: ["Soporte remoto 24/7", "Consultoría técnica", "Resolución de casos complejos"],
      price: "Consultar precio"
    },
    {
      icon: "ri-graduation-cap-line",
      title: "Capacitación Profesional",
      description: "Programas de entrenamiento para técnicos automotrices",
      features: ["Cursos presenciales", "Certificaciones", "Material didáctico"],
      price: "Consultar precio"
    },
    {
      icon: "ri-tools-fill",
      title: "Equipos Especializados",
      description: "Venta y alquiler de equipos de diagnóstico profesional",
      features: ["Equipos de última generación", "Mantenimiento incluido", "Actualizaciones gratuitas"],
      price: "Consultar precio"
    },
    {
      icon: "ri-settings-3-line",
      title: "Servicios de Programación",
      description: "Programación de módulos y llaves para otros talleres",
      features: ["Programación ECU/BCM", "Llaves inteligentes", "Servicios express"],
      price: "Consultar precio"
    }
  ];

  const benefits = [
    {
      icon: "ri-money-dollar-circle-line",
      title: "Precios Preferenciales",
      description: "Tarifas especiales para talleres y empresas del sector automotriz"
    },
    {
      icon: "ri-truck-line",
      title: "Servicio a Domicilio",
      description: "Llevamos nuestros servicios directamente a tu taller"
    },
    {
      icon: "ri-time-line",
      title: "Respuesta Rápida",
      description: "Atención prioritaria con tiempos de respuesta garantizados"
    },
    {
      icon: "ri-team-line",
      title: "Equipo Dedicado",
      description: "Técnicos especializados asignados a tu cuenta empresarial"
    }
  ];

  const testimonials = [
    {
      name: "Carlos Rodríguez",
      company: "Taller Automotriz El Experto",
      text: "Mechatronicx nos ha ayudado a resolver casos complejos que no podíamos manejar internamente. Su soporte técnico es excepcional.",
      rating: 5
    },
    {
      name: "María González",
      company: "AutoServicios González",
      text: "La capacitación que recibimos nos permitió ampliar nuestros servicios y aumentar significativamente nuestros ingresos.",
      rating: 5
    },
    {
      name: "Luis Martínez",
      company: "Diagnóstico Profesional SAS",
      text: "Los equipos que adquirimos han transformado nuestro taller. La calidad y el soporte post-venta son inmejorables.",
      rating: 5
    }
  ];

  useEffect(() => {
    // Add structured data for business page
    const structuredData = {
      "@context": "https://schema.org",
      "@type": "WebPage",
      "name": "Soluciones Empresariales B2B - Mechatronicx SAS",
      "description": "Servicios especializados para talleres automotrices y empresas del sector",
      "url": `${import.meta.env.VITE_SITE_URL || 'https://example.com'}/empresas`,
      "mainEntity": {
        "@type": "Service",
        "name": "Soluciones Empresariales B2B",
        "provider": {
          "@type": "Organization",
          "name": "Mechatronicx SAS",
          "url": `${import.meta.env.VITE_SITE_URL || 'https://example.com'}`
        },
        "serviceType": "Soporte Técnico Empresarial",
        "audience": {
          "@type": "BusinessAudience",
          "audienceType": "Talleres Automotrices"
        }
      }
    };

    const script = document.createElement('script');
    script.type = 'application/ld+json';
    script.text = JSON.stringify(structuredData);
    document.head.appendChild(script);

    return () => {
      if (document.head.contains(script)) {
        document.head.removeChild(script);
      }
    };
  }, []);

  return (
    <div className="min-h-screen bg-white">
      {/* Header */}
      <header className="bg-white shadow-lg fixed w-full top-0 z-50">
        <div className="container mx-auto px-4 py-4">
          <div className="flex items-center justify-between">
            <Link to="/" className="flex items-center space-x-3 cursor-pointer">
              <img 
                src="https://static.readdy.ai/image/96943797dbdaaac8c737f0ff7f16d86a/db14669796bfd9c6751821edba8bd22a.png" 
                alt="Mechatronicx Logo" 
                className="h-12 w-auto"
              />
              <div>
                <h1 className="text-xl font-bold text-gray-900">MECHATRONICX</h1>
                <p className="text-xs text-gray-600">Soluciones Electrónicas Automotrices</p>
              </div>
            </Link>
            <nav className="hidden lg:flex items-center space-x-6 xl:space-x-8">
              <Link to="/" className="text-gray-700 hover:text-red-600 transition-colors cursor-pointer">Inicio</Link>
              <Link to="/servicios" className="text-gray-700 hover:text-red-600 transition-colors cursor-pointer">Servicios</Link>
              <Link to="/productos" className="text-gray-700 hover:text-red-600 transition-colors cursor-pointer">Productos</Link>
              <Link to="/empresas" className="text-red-600 font-semibold cursor-pointer">Empresas</Link>
              <Link to="/blog" className="text-gray-700 hover:text-red-600 transition-colors cursor-pointer">Blog</Link>
              <a 
                href="https://wa.me/573202047129"
                target="_blank"
                rel="noopener noreferrer"
                className="bg-red-600 text-white px-4 xl:px-6 py-2 rounded-full hover:bg-red-700 transition-colors whitespace-nowrap cursor-pointer text-sm xl:text-base"
              >
                Cotizar Ahora
              </a>
            </nav>
          </div>
        </div>
      </header>

      {/* Hero Section */}
      <section className="bg-gradient-to-r from-gray-900 to-red-900 text-white py-20 mt-20">
        <div className="container mx-auto px-4">
          <div className="grid lg:grid-cols-2 gap-12 items-center">
            <div>
              <h1 className="text-5xl font-bold mb-6 leading-tight">
                Soluciones Empresariales B2B
              </h1>
              <p className="text-xl mb-8 text-gray-200">
                Potencia tu taller automotriz con nuestros servicios especializados. 
                Ofrecemos soporte técnico, capacitación y equipos profesionales para 
                talleres que buscan expandir sus capacidades.
              </p>
              <div className="flex flex-col sm:flex-row gap-4">
                <button 
                  onClick={handleWhatsAppContact}
                  className="bg-red-600 text-white px-8 py-4 rounded-full text-lg font-semibold hover:bg-red-700 transform hover:scale-105 transition-all whitespace-nowrap cursor-pointer"
                >
                  Solicitar Información
                </button>
                <button 
                  onClick={handleScheduleMeeting}
                  className="border-2 border-white text-white px-8 py-4 rounded-full text-lg font-semibold hover:bg-white hover:text-gray-900 transition-all whitespace-nowrap cursor-pointer"
                >
                  Agendar Reunión
                </button>
              </div>
            </div>
            <div className="relative">
              <img 
                src="https://public.readdy.ai/ai/img_res/86bca34ad8efaaa5a27b80758b8437e2.jpg"
                alt="Soluciones B2B"
                className="rounded-2xl shadow-2xl"
              />
            </div>
          </div>
        </div>
      </section>

      {/* Services Section */}
      <section className="py-20 bg-gray-50">
        <div className="container mx-auto px-4">
          <div className="text-center mb-16">
            <h2 className="text-4xl font-bold text-gray-900 mb-4">Servicios para Talleres</h2>
            <p className="text-xl text-gray-600 max-w-3xl mx-auto">
              Diseñamos soluciones específicas para talleres automotrices que buscan 
              ampliar sus capacidades y ofrecer servicios más especializados.
            </p>
          </div>

          <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8">
            {b2bServices.map((service, index) => (
              <div 
                key={index}
                className="bg-white rounded-2xl p-8 shadow-lg hover:shadow-xl transform hover:-translate-y-2 transition-all duration-300 cursor-pointer"
              >
                <div className="w-16 h-16 bg-red-100 rounded-full flex items-center justify-center mb-6">
                  <i className={`${service.icon} text-2xl text-red-600`}></i>
                </div>
                <h3 className="text-xl font-bold text-gray-900 mb-4">{service.title}</h3>
                <p className="text-gray-600 mb-6">{service.description}</p>
                <ul className="space-y-2 mb-6">
                  {service.features.map((feature, idx) => (
                    <li key={idx} className="flex items-center text-sm text-gray-700">
                      <i className="ri-check-line text-green-500 mr-2"></i>
                      {feature}
                    </li>
                  ))}
                </ul>
                <div className="border-t pt-4">
                  <p className="text-lg font-bold text-red-600">{service.price}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Benefits Section */}
      <section className="py-20 bg-white">
        <div className="container mx-auto px-4">
          <div className="text-center mb-16">
            <h2 className="text-4xl font-bold text-gray-900 mb-4">Beneficios Empresariales</h2>
            <p className="text-xl text-gray-600 max-w-3xl mx-auto">
              Al asociarte con Mechatronicx, obtienes ventajas exclusivas que te ayudarán 
              a hacer crecer tu negocio automotriz.
            </p>
          </div>

          <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8">
            {benefits.map((benefit, index) => (
              <div 
                key={index}
                className="text-center p-6 rounded-2xl hover:bg-gray-50 transition-all duration-300 cursor-pointer"
              >
                <div className="w-20 h-20 bg-red-100 rounded-full flex items-center justify-center mx-auto mb-6">
                  <i className={`${benefit.icon} text-3xl text-red-600`}></i>
                </div>
                <h3 className="text-xl font-bold text-gray-900 mb-4">{benefit.title}</h3>
                <p className="text-gray-600">{benefit.description}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Testimonials Section */}
      <section className="py-20 bg-gray-50">
        <div className="container mx-auto px-4">
          <div className="text-center mb-16">
            <h2 className="text-4xl font-bold text-gray-900 mb-4">Lo Que Dicen Nuestros Socios</h2>
            <p className="text-xl text-gray-600 max-w-3xl mx-auto">
              Talleres automotrices que han transformado su negocio con nuestras soluciones
            </p>
          </div>

          <div className="grid md:grid-cols-3 gap-8">
            {testimonials.map((testimonial, index) => (
              <div 
                key={index}
                className="bg-white rounded-2xl p-8 shadow-lg hover:shadow-xl transition-all duration-300"
              >
                <div className="flex text-yellow-400 mb-4">
                  {[...Array(testimonial.rating)].map((_, i) => (
                    <i key={i} className="ri-star-fill text-lg"></i>
                  ))}
                </div>
                <p className="text-gray-600 mb-6 italic">"{testimonial.text}"</p>
                <div>
                  <h4 className="font-bold text-gray-900">{testimonial.name}</h4>
                  <p className="text-sm text-gray-500">{testimonial.company}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="py-20 bg-gradient-to-r from-gray-900 to-red-900 text-white">
        <div className="container mx-auto px-4 text-center">
          <h2 className="text-4xl font-bold mb-6">¿Listo para Hacer Crecer tu Taller?</h2>
          <p className="text-xl mb-8 max-w-3xl mx-auto">
            Únete a la red de talleres especializados que confían en Mechatronicx. 
            Solicita una consulta gratuita y descubre cómo podemos ayudarte.
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <a 
              href="https://wa.me/573202047129"
              target="_blank"
              rel="noopener noreferrer"
              className="bg-green-600 text-white px-8 py-4 rounded-full text-lg font-semibold hover:bg-green-700 transform hover:scale-105 transition-all whitespace-nowrap cursor-pointer inline-block text-center"
            >
              <i className="ri-whatsapp-line mr-2"></i>
              Consulta Gratuita por WhatsApp
            </a>
          </div>
        </div>
      </section>

      {/* Footer */}
      <footer className="bg-gray-900 text-white py-16">
        <div className="container mx-auto px-4">
          <div className="grid md:grid-cols-4 gap-8">
            <div>
              <div className="flex items-center space-x-3 mb-6">
                <img 
                  src="https://static.readdy.ai/image/96943797dbdaaac8c737f0ff7f16d86a/db14669796bfd9c6751821edba8bd22a.png" 
                  alt="Mechatronicx Logo" 
                  className="h-10 w-auto"
                />
                <div>
                  <h3 className="text-lg font-bold">MECHATRONICX</h3>
                  <p className="text-xs text-gray-400">Soluciones Electrónicas</p>
                </div>
              </div>
              <p className="text-gray-400 mb-4">
                Socios estratégicos para el crecimiento de tu taller automotriz.
              </p>
            </div>

            <div>
              <h4 className="text-lg font-bold mb-6">Servicios B2B</h4>
              <ul className="space-y-3">
                <li><a href="#" className="text-gray-400 hover:text-white transition-colors cursor-pointer">Soporte Técnico</a></li>
                <li><a href="#" className="text-gray-400 hover:text-white transition-colors cursor-pointer">Capacitación</a></li>
                <li><a href="#" className="text-gray-400 hover:text-white transition-colors cursor-pointer">Equipos Especializados</a></li>
                <li><a href="#" className="text-gray-400 hover:text-white transition-colors cursor-pointer">Programación</a></li>
              </ul>
            </div>

            <div>
              <h4 className="text-lg font-bold mb-6">Contacto</h4>
              <div className="space-y-3">
                <div className="flex items-center">
                  <i className="ri-map-pin-line text-red-500 mr-3"></i>
                  <span className="text-gray-400">Ave Cra 30 #29-09 Sur, Bogotá DC</span>
                </div>
                <div className="flex items-center">
                  <i className="ri-phone-line text-red-500 mr-3"></i>
                  <span className="text-gray-400">320 204 7129</span>
                </div>
                <div className="flex items-center">
                  <i className="ri-mail-line text-red-500 mr-3"></i>
                  <span className="text-gray-400">Gerencia@mechatronicxsas.com</span>
                </div>
              </div>
            </div>

            <div>
              <h4 className="text-lg font-bold mb-6">Síguenos</h4>
              <div className="flex space-x-4">
                <a href="https://www.facebook.com/people/Mechatronicx-Especializado/100083428926459/?mibextid=wwXIfr&rdid=8FbzdNPEAxjlrs6r&share_url=https%3A%2F%2Fwww.facebook.com%2Fshare%2F14SQyQT5X5o%2F%3Fmibextid%3DwwXIfr" target="_blank" rel="noopener noreferrer" className="text-gray-400 hover:text-white transition-colors cursor-pointer">
                  <i className="ri-facebook-fill text-lg md:text-xl"></i>
                </a>
                <a href="https://www.instagram.com/mechatronicxsas/?igsh=MTh0eDQ3MWhnMmh1NA%3D%3D" target="_blank" rel="noopener noreferrer" className="text-gray-400 hover:text-white transition-colors cursor-pointer">
                  <i className="ri-instagram-line text-lg md:text-xl"></i>
                </a>
              </div>
            </div>
          </div>

          <div className="border-t border-gray-800 mt-12 pt-8 text-center">
            <p className="text-gray-400">
              © 2024 Mechatronicx SAS. Todos los derechos reservados. | 
              <a href="https://maiketing.agency" target="_blank" rel="noopener noreferrer" className="text-red-500 hover:text-red-400 ml-1 cursor-pointer">
                Powered by MAIketing.agency
              </a>
            </p>
          </div>
        </div>
      </footer>
    </div>
  );
};

export default EmpresasPage;
